import { ValveType, ValveDirection, UpdateRadiatorRequest } from '@lib/api';
import * as yup from 'yup';
import i18n from 'i18next';

/*const numberSchema = yup
  .number()
  .transform((curr, orig) => (orig === '' ? null : curr))
  .nullable()
  .typeError(i18n.t('invalid_number_error', { ns: 'misc' }))
  .integer(i18n.t('whole_numbers_only_error', { ns: 'misc' }))
  .positive(i18n.t('positive_number_only_error', { ns: 'misc' }));*/

export const RadiatorSchema: yup.ObjectSchema<UpdateRadiatorRequest> = yup.object({
  name: yup.string().required(i18n.t('required', { ns: 'common' })),
  //radiatorType: yup.mixed<RadiatorType>().nullable(),
  //dataGatheringStatus: yup.mixed<DataGatheringStatus>().required(),
  valveType: yup.mixed<ValveType>().nullable(),
  //plateRadiatorSubtype: yup.mixed<PlateRadiatorSubtype>().nullable(),
  valveDirection: yup.mixed<ValveDirection>().nullable(),
  //length: numberSchema,
  //width: numberSchema,
  //height: numberSchema,
  //radiatorTypeOther: yup.string().nullable(),
  //sectionalRadiatorSpacing: numberSchema,
  installationNotPossible: yup.boolean().nullable(),
  radiatorNotAccessible: yup.boolean().nullable(),
  incompatibleValve: yup.boolean().nullable(),
  defectiveValve: yup.boolean().nullable(),
  installationNotPossibleDescription: yup.string().nullable(),
  description: yup.string().nullable(),
  hkvId: yup.string().nullable(),
});
